var _defs, _rect, _path, _rect2, _polyline, _line, _polyline2, _line2, _polyline3, _line3, _polyline4, _line4, _path2, _path3, _path4, _path5, _text;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-7,.cls-8,.cls-9{fill:#54575a;}.cls-3{fill:#47b972;}.cls-4,.cls-5,.cls-6{fill:none;}.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke:#54575a;stroke-miterlimit:10;}.cls-4,.cls-5,.cls-6,.cls-8{stroke-width:15px;}.cls-5{stroke-dasharray:47.23 47.23;}.cls-6{stroke-dasharray:49.65 49.65;}.cls-9{font-size:476.71px;font-family:Roboto-Bold, Roboto;font-weight:700;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.5,
    y: 25.5,
    width: 1149,
    height: 1149,
    rx: 95.94,
    ry: 95.94
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1078.56,35.5a86.26,86.26,0,0,1,85.94,85.94v957.11a86.26,86.26,0,0,1-85.94,85.94H121.44a86.26,86.26,0,0,1-85.94-85.94V121.44A86.26,86.26,0,0,1,121.44,35.5h957.11m0-20H121.44C63.18,15.5,15.5,63.18,15.5,121.44v957.11c0,58.27,47.68,105.94,105.94,105.94h957.11c58.27,0,105.94-47.68,105.94-105.94V121.44c0-58.27-47.68-105.94-105.94-105.94Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 153.5,
    y: 302.5,
    width: 894,
    height: 664
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "1022.5 302.5 1047.5 302.5 1047.5 327.5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1047.5,
    y1: 374.73,
    x2: 1047.5,
    y2: 917.88
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "1047.5 941.5 1047.5 966.5 1022.5 966.5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 972.85,
    y1: 966.5,
    x2: 203.32,
    y2: 966.5
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "178.5 966.5 153.5 966.5 153.5 941.5"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 153.5,
    y1: 894.27,
    x2: 153.5,
    y2: 351.12
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "153.5 327.5 153.5 302.5 178.5 302.5"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 228.15,
    y1: 302.5,
    x2: 997.68,
    y2: 302.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M846.34,383.65,582.94,239.59s48.15-14.1,66.23-7.33,220.3,120.49,220.3,120.49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M839.49,223.92,582.94,379.85s48.75,11.89,66.49,4.3S864,253.73,864,253.73Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M878.46,340c25.43-.19,46.19,20.52,46.38,46.25s-20.27,46.75-45.7,46.94-46.19-20.52-46.38-46.25S853,340.15,878.46,340Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M873.21,172.1c25.24-3.12,48.2,15.05,51.29,40.6s-14.87,48.78-40.12,51.91-48.2-15.05-51.29-40.6S848,175.22,873.21,172.1Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(424.41 838.81)"
  }, "%")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.a70d9e51cf2ed10d99e9b06048818fc5.svg";
export { ForwardRef as ReactComponent };